<div class="promo-codes-restrictions">
  <h2>Restrictions (optional)</h2>

  <section fxLayout="column" fxLayoutGap="24px">
    <div fxLayout="column">
      <label class="strong">Expires</label>

      <div fxLayout fxLayoutGap="8px">
        <mat-form-field
          class="nopadding"
          fxFlex="320px"
          #dateMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="dateMenu">
          <input
            matInput
            placeholder="Does not expire"
            readonly
            [value]="promoCode.restrictions.expires_at | date: 'mediumDate'" />
          <button
            *ngIf="promoCode.restrictions.expires_at"
            class="button__clear"
            matSuffix
            aria-label="Clear"
            (click)="$event.preventDefault(); $event.stopPropagation(); promoCode.restrictions.expires_at = null">
            x
          </button>
        </mat-form-field>
      </div>
      <span class="card__collapsed-helper-text">Booking must be requested on or before this day</span>
    </div>

    <div fxLayout="column">
      <label class="strong">Qualifying stays</label>

      <div class="date-restrictions" fxLayout fxLayoutGap="8px" fxLayout.lt-md="column">
        <mat-form-field
          class="nopadding"
          fxFlex
          #earliestCheckInMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="earliestCheckInMenu">
          <input
            matInput
            placeholder="Earliest check-in"
            readonly
            [value]="promoCode.restrictions.earliest_check_in_at | date: 'mediumDate'" />
          <button
            *ngIf="promoCode.restrictions.earliest_check_in_at"
            class="button__clear"
            matSuffix
            aria-label="Clear"
            (click)="
              $event.preventDefault(); $event.stopPropagation(); promoCode.restrictions.earliest_check_in_at = null
            ">
            x
          </button>
        </mat-form-field>

        <span fxFlex="0 0 24px" fxFlex.lt-md="0 0 auto" class="to-separator">to</span>

        <mat-form-field
          class="nopadding"
          fxFlex
          #latestCheckOutMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="latestCheckOutMenu">
          <input
            matInput
            type="tel"
            placeholder="Latest check-out"
            readonly
            [value]="promoCode.restrictions.latest_check_out_at | date: 'mediumDate'" />
          <button
            *ngIf="promoCode.restrictions.latest_check_out_at"
            class="button__clear"
            matSuffix
            aria-label="Clear"
            (click)="
              $event.preventDefault(); $event.stopPropagation(); promoCode.restrictions.latest_check_out_at = null
            ">
            x
          </button>
        </mat-form-field>
      </div>
      <span class="card__collapsed-helper-text">Only stays during this period are eligible for the discount</span>
    </div>

    <div fxLayout="column">
      <label class="strong">Uses</label>

      <div fxLayout fxLayoutGap="8px">
        <mat-form-field class="nopadding" fxFlex="320px">
          <input
            matInput
            type="number"
            min="1"
            placeholder="Unlimited uses"
            [(ngModel)]="promoCode.restrictions.max_uses"
            (change)="positiveValueCheck('promoCode.restrictions.max_uses')" />
        </mat-form-field>
      </div>
      <span class="card__collapsed-helper-text">Restrict the number of times this code can be redeemed</span>
    </div>

    <div fxLayout="column">
      <label class="strong">Minimum length of stay</label>

      <div fxLayout fxLayoutGap="8px">
        <mat-form-field class="nopadding" fxFlex="320px">
          <input
            matInput
            type="number"
            min="1"
            placeholder="0"
            [(ngModel)]="promoCode.restrictions.min_length_of_stay"
            (change)="positiveValueCheck('promoCode.restrictions.min_length_of_stay')" />
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="column" *ngIf="promoCode.discount_type !== PromoCodeType.Percentage">
      <label class="strong">Minimum booking value</label>

      <div fxLayout fxLayoutGap="8px">
        <mat-form-field class="nopadding" fxFlex="320px">
          <input
            matInput
            type="number"
            min="1"
            placeholder="0"
            [(ngModel)]="promoCode.restrictions.min_booking_value"
            (change)="positiveValueCheck('promoCode.restrictions.min_booking_value')" />
        </mat-form-field>
      </div>

      <span class="card__collapsed-helper-text">Sum of nightly rates before fees</span>
    </div>

    <div fxLayout="column">
      <div fxLayout fxLayoutGap="8px">
        <mat-slide-toggle
          [checked]="!promoCode.restrictions.stacks_with_length_of_stay_discounts"
          (change)="
            promoCode.restrictions.stacks_with_length_of_stay_discounts =
              !promoCode.restrictions.stacks_with_length_of_stay_discounts
          ">
          <label class="strong">Cannot be combined with length of stay discounts</label>
        </mat-slide-toggle>
      </div>
    </div>
  </section>
</div>

<mat-menu #dateMenu="matMenu" class="filters__cdk-menu">
  <div (click)="$event.preventDefault(); $event.stopPropagation()">
    <sbnb-date-picker
      [numMonths]="1"
      [checkInOutStyling]="false"
      [showDurationLabels]="false"
      (datesSelected)="
        promoCode.restrictions.expires_at = formatDate($event); dateMenuTrigger.closeMenu()
      "></sbnb-date-picker>
  </div>
</mat-menu>

<mat-menu #earliestCheckInMenu="matMenu" class="filters__cdk-menu">
  <div (click)="$event.preventDefault(); $event.stopPropagation()">
    <sbnb-date-picker
      [numMonths]="1"
      [checkInOutStyling]="false"
      [showDurationLabels]="false"
      (datesSelected)="
        promoCode.restrictions.earliest_check_in_at = formatDate($event); earliestCheckInMenuTrigger.closeMenu()
      "></sbnb-date-picker>
  </div>
</mat-menu>

<mat-menu #latestCheckOutMenu="matMenu" class="filters__cdk-menu">
  <div (click)="$event.preventDefault(); $event.stopPropagation()">
    <sbnb-date-picker
      [numMonths]="1"
      [checkInOutStyling]="false"
      [showDurationLabels]="false"
      (datesSelected)="
        promoCode.restrictions.latest_check_out_at = formatDate($event); latestCheckOutMenuTrigger.closeMenu()
      "></sbnb-date-picker>
  </div>
</mat-menu>
